<template>
  <section class="section-base">
    <div class="container">
      <div class="row row-fit-lg" data-anima="fade-bottom" data-time="300">
        <div class="col-lg-6">
          <carousel :scrollPerPage="true" :navigationEnabled="true"
                    navigationNextLabel="<i class='fa fa-regular fa-angle-right'></i>"
                    navigationPrevLabel="<i class='fa fa-regular fa-angle-left'></i>"
                    :perPageCustom="[[480, 1], [768, 1]]">
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/chint_img.jpg')" alt="">
                <span>CHINT</span>
              </a>
            </slide>
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/dahsolar_img.jpg')" alt="">
                <span>DAH SOLAR</span>
              </a>
            </slide>
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/growatt_img.jpg')" alt="">
                <span>GROWATT</span>
              </a>
            </slide>
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/amerisolar_img.jpg')" alt="">
                <span>AMERISOLAR</span>
              </a>
            </slide>
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/saj_img.jpg')" alt="">
                <span>SAJ</span>
              </a>
            </slide>
            <slide>
              <a class="img-box img-box-caption lightbox" href="#" data-lightbox-anima="fade-top">
                <img :src="require('Assets/images/canadian_img.jpg')" alt="">
                <span>CANADIAN</span>
              </a>
            </slide>
          </carousel>
        </div>
        <div class="col-lg-6">
          <div class="title">
            <h2>Marcas Parceiras</h2>
            <p>SOBRE NOSSOS FORNECEDORES</p>
          </div>
          <p align="justify">
            &nbsp;&nbsp;Entregar sustentabilidade, qualidade e responsabilidade é a base das nossas
            diretrizes, para isso contamos com os maiores e melhores fabricantes mundiais do
            segmento solar. <br><br>&nbsp;&nbsp;Respeitando nossas premissas sociais, éticas e
            ambientais alinhados a qualidade, certificação e homologação em laboratórios nacionais e
            internacionais temos a garantia em alcançar um crescimento sustentável com nossos
            parceiros.
          </p>

        </div>
      </div>
      <br><br>
      <table class="table table-grid table-border table-logos table-full-sm"
             data-anima="fade-bottom" data-time="1000">
        <tbody>
        <tr>
          <td><img :src="require('Assets/images/chint.png')" alt=""/></td>
          <td><img :src="require('Assets/images/growatt.png')" alt=""/></td>
          <td><img :src="require('Assets/images/saj.png')" alt=""/></td>
          <td><img :src="require('Assets/images/dah.png')" alt=""/></td>
          <td><img :src="require('Assets/images/amerisolar.png')" alt=""/></td>
          <td><img :src="require('Assets/images/canadian.png')" alt=""/></td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'MarcasParceiras',
  components: {
    Carousel,
    Slide,
  },
};
</script>
<!--VueCarousel-navigation-prev-->
<style>
.section-base .VueCarousel-dot-container {
  display: none !important;
}
.VueCarousel-navigation-button {
  height: 30px !important;
  color: #FFF !important;
  font-weight: bold !important;
  /*font-family: 'Montserrat', sans-serif !important;*/
  font-family: "Icons";
  content: "\68";
  font-size: 25px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  transition: all .5s;
}
.VueCarousel-navigation-next {
  right: 30px !important;
}
.VueCarousel-navigation-prev {
  left: 30px !important;
}
.VueCarousel-navigation-button[data-v-453ad8cd]:focus {
  outline: none !important;
}
</style>
